module.exports = __webpack_public_path__ + "img/linkd2-1.9252867b.webp";